// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeTeamPlayerStatsGetBody = {
  teamId: string;
};

export type typeTeamPlayerStatsGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    teamId: string;
    leagueId: string;
    leagueSeasonId?: string | null;
    seasonLabel?: string | null;
    hasStats: boolean;
    tables: {
      key: string;
      label: string;
      columns: { key: string; label: string }[];
      rows: {
        playerId: string;
        name: string;
        position?: string | null;
        headshotUrl?: string | null;
        cells: { key: string; display: string }[];
      }[];
    }[];
  };
};

export type typeTeamPlayerStatsGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamPlayerStatsGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeTeamPlayerStatsGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaTeamPlayerStatsGetBody = {
  type: "object",
  properties: { teamId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["teamId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createTeamPlayerStatsGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaTeamPlayerStatsGetBody);
  }

  return async function postTeamPlayerStatsGet(
    payload: typeTeamPlayerStatsGetBody,
  ): Promise<
    typeTeamPlayerStatsGetOutput200 | typeTeamPlayerStatsGetOutput400
  > {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postTeamPlayerStatsGet" failed before calling the network. #8b0bcd9c4d8f`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#8b0bcd9c4d8f" },
        },
        data: null,
      } as typeTeamPlayerStatsGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/team/player-stats-get`,
      httpMethod: "POST",
      options,
    })) as typeTeamPlayerStatsGetOutput200 | typeTeamPlayerStatsGetOutput400;
  };
}
